export const SET_PROJECT_USERS_LIST_ERROR = 'SET_PROJECT_USERS_LIST_ERROR';
export const SET_PROJECT_USERS_LIST = 'SET_PROJECT_USERS_LIST';
export const SET_TOTAL_AMOUNT_OF_PROJECT_USERS = 'SET_TOTAL_AMOUNT_OF_PROJECT_USERS';
export const SET_AVAILABLE_PROJECT_USERS_LIST = 'SET_AVAILABLE_PROJECT_USERS_LIST';
export const SET_FETCHING_PROJECT_USERS = 'SET_FETCHING_PROJECT_USERS';